module.exports = __webpack_public_path__ + "img/dashboard.b7cebaa0.jpg";